import router from './router'
import store from './store'
import {
	getToken
} from './utils/auth' // 验权

const whiteList = ['/login', 'error']
router.beforeEach((to, from, next) => {
const userInfoToken = store.state.userInfo?JSON.parse(store.state.userInfo).token:''
	if (getToken() && userInfoToken) {
		store.dispatch('isLogin', getToken()).then(res => {
			if (res.code === 0) {
				if (to.path === '/login') {
					next({
						path: '/'
					})
				} else {
					next()
				}
			} else {
				store.commit('SET_USERINFO', '');
				store.dispatch('logout').then(res => {
					next('/login')
				})

			}
		}).catch(error => {
			store.dispatch('logout').then(res => {
				next('/login')
			}).catch(error => {
				console.log('-------------------error',error)
				store.commit('SET_USERINFO', '');
				if (to.path !== '/login') {
					next('/login');
				} else {
					next();
				}

			})
		})
	} else {
		if (whiteList.indexOf(to.path) !== -1) {
			next()
		} else if (to.path !== '/login' && from.path !== '/login') {
			next('/login')
		} else {
			next()
		}
	}
})
